export default {
    find:                       { method: 'get',    url: 'teacher_contracts' },
    create:                     { method: 'post',   url: 'teacher_contracts'},
    update:                     { method: 'put',    url: 'teacher_contracts/{id}'},
    delete:                     { method: 'delete', url: 'teacher_contracts/{id}'},
    indexTeacherContractTypes:  { method: 'get',    url: 'teacher_contracts/types' },
}